export default '/static/frontend/ReachDigital/12gobiking/dist/assets/shopping-awards-26ff31e1.svg'